import { GetImages } from "../../../utils/GetImages";

const AddButtonWithArrow = ({
  buttonname,
  onClick = (value: any) => { },
  disabled = undefined,
  iconDirection = undefined,
  Icon = undefined,
  id = undefined,
  type = undefined,
  className = undefined,
  btnTextClass = undefined,
  minWidth = undefined,
  loading = false
}) => {

  return (
    <>
      <button
        type={type}
        className={`getStartedButtonadd  ${className ? className : "getStartedButtonadd"}`}
        onClick={onClick}
        style={{ minWidth: minWidth }}
        disabled={disabled}
        id={id}
      >
        {iconDirection == "right" ? (
          <>
            <img className="iconstyle11" src={Icon} alt={buttonname} />
            <p className="sub_text white fw-600">{buttonname} </p>
          </>
        ) : iconDirection == "left" ? (
          <>
            <p className="sub_text white fw-600">{buttonname} </p>
            <img className="iconstyle11" src={Icon} alt={buttonname} />
          </>
        ) : (
          <p className={disabled ? "grey sub_text fw-600" : `${btnTextClass} sub_text white fw-600`}>
            {loading ? <img className="iconstyle18" src={GetImages.loadingGif} /> : buttonname}
          </p>
        )}
      </button>
    </>
  );
};

export default AddButtonWithArrow;
